import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
// Ag-Grid
import {
  GridOptions,
  GridApi,
  ColDef,
  RowSelectionOptions,
} from 'ag-grid-community';
import { agGridDarkTheme } from 'src/app/shared/components/ag-grid/dark-theme';
import { AgGridAngular } from 'ag-grid-angular';
// Services
import { SharedService } from '../shared/services/shared.service';
// Third Party
import { Subscription } from 'rxjs';
import { Reserved4473TableColumnDef } from './columnDefs';
import { RevertBtnComponent } from '../shared/components/ag-grid/revert-btn/revert-btn.component';
import {
  Answers,
  ModalID,
  Questions,
  StatusModalIndicator,
} from '../shared/models/constants';
import { Form4473Transferee, Reserved4473 } from '../shared/models/general';
import { ReCertBtnComponent } from './re-cert-btn/re-cert-btn/re-cert-btn.component';

@Component({
  selector: 'app-reserved-4473',
  templateUrl: './reserved-4473.component.html',
  styleUrl: './reserved-4473.component.scss',
  standalone: true,
  imports: [AgGridAngular],
})
export class Reserved4473Component {
  subscriptions = new Subscription();
  private destroyRef = inject(DestroyRef);
  public rowSelection: RowSelectionOptions = {
    mode: 'singleRow',
    enableSelectionWithoutKeys: true,
    checkboxes: false,
  };
  // ag-grid properties Grid
  gridApi!: GridApi;

  columnDefs: ColDef[] = Reserved4473TableColumnDef;
  defaultColDef;
  //sideBar;
  // detailCellRendererParams;
  // statusBar;
  detailCellRendererParams: any;
  overlayLoadingTemplate;
  overlayNoRowsTemplate;
  gridOptions: GridOptions = {
    theme: agGridDarkTheme,};
  components: any;
  theme = agGridDarkTheme;

  constructor(public sharedService: SharedService) {
    this.gridOptions = <GridOptions>{};
    this.gridOptions.headerHeight = 50;
    this.gridOptions.rowHeight = 28;
    this.gridOptions.context = { ConfigComponent: this }; // this allows access to component functions
    this.gridOptions.rowClass = 'ag-grid-row';
    this.defaultColDef = {
      sortable: true,
      filter: true,
      resizable: true,
      floatingFilter: true,
      wrapHeaderText: true,
    };
    this.components = {
      RevertBtn: RevertBtnComponent,
      RecertBtn: ReCertBtnComponent,
    };
    // yes / no submit
    this.subscriptions.add(
      this.sharedService.yes_no_submit$
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe((response) => {
          if (
            response['answer'] === Answers.yes &&
            response['question'] === Questions.remove_4473
          ) {
            const reserved_4473 = response['optional_details'][
              'colValues'
            ] as Form4473Transferee;
            this.remove4473FromList(reserved_4473);
          }
        }),
    );
  }

  onGridReady(params: any) {
    this.gridApi = params.api;
  }
  async ngOnInit() {
    this.addButtonColumns();
    await this.getReserved4473sRecords();
  }
  async getReserved4473sRecords() {
    if (this.sharedService.reserved_4473_list.length === 0) {
      this.sharedService.openStatusSpinner('Retrieving Reserved 4473s');
      await this.sharedService.getReserved4473List();
      this.sharedService.closeStatusSpinner();
    }
  }
  addButtonColumns() {
    const hasRecert = this.columnDefs.some(
      (column) => column.headerName === 'Recert Needed',
    );
    if (!hasRecert) {
      this.columnDefs.push({
        headerName: 'Recert Needed',
        field: 'recert',
        resizable: true,
        width: 175,
        pinned: 'right',
        cellRenderer: 'RecertBtn',
        cellRendererParams: {
          recertClick: this.recert4473Click.bind(this),
        },
      });
    }
    const hasEditDelete = this.columnDefs.some(
      (column) => column.headerName === 'Delete / Select',
    );
    if (!hasEditDelete) {
      this.columnDefs.push({
        headerName: 'Delete / Select',
        field: 'delete_select',
        resizable: true,
        width: 200,
        pinned: 'right',
        cellRenderer: 'RevertBtn',
        cellRendererParams: {
          revertItemClick: this.delete4473Click.bind(this),
          selectItemClick: this.select4473Click.bind(this),
        },
      });
    }
  }
  delete4473Click(data) {
    this.sharedService.openYesNoModal(Questions.remove_4473, data);
  }
  select4473Click(data) {
    if (!this.sharedService.dispo_build_modal_shown) {
      this.sharedService.changeRoute('disposition');
    } else {
      this.sharedService.closeModal(ModalID.dispo_build);
      this.sharedService.dispo_build_selected_transferee_4473 = data[
        'colValues'
      ] as Form4473Transferee;
      this.sharedService.build_disposition.buyer_4473 = data[
        'colValues'
      ] as Form4473Transferee;
      this.sharedService.reserved_4473_transferee_selected$.next(
        data['colValues'] as Form4473Transferee,
      );
    }
  }
  recert4473Click(data) {
    console.log('recert form', data);
    this.sharedService.openKioskSelection();
  }
  async remove4473FromList(reserved_4473: Form4473Transferee) {
    this.sharedService.deleteReserved4473(reserved_4473);
    // console.warn(reserved_firearm.reservation_id);
    // await this.sharedService.deleteFirearmFromReserveList(reserved_firearm.reservation_id);
    // let bound_book_entry = this.sharedService.bound_book.filter( entry => entry.bound_book_id === reserved_firearm.bound_book_id)[0];
    // bound_book_entry.state = State.acquisition;
    // await this.sharedService.updateBoundBookEntry(bound_book_entry);
  }
  closeComponent() {
    if (this.sharedService.dispo_build_modal_shown) {
      this.sharedService.closeModal(ModalID.dispo_build);
      setTimeout(() => {
        this.sharedService.dispo_build_modal_shown = false;
      }, 200);
    } else {
      this.sharedService.changeRoute('home');
    }
  }
  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
}
